import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import { post } from "../../../helpers/api_helper";
import Swal from 'sweetalert2';

// Fetch Grace Policy
function* fetchGracePolicySaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_GRACE_POLICY, formData);
    yield put({ type: types.FETCH_GRACE_POLICY_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.FETCH_GRACE_POLICY_FAILURE, payload: error });
  }
}

// Save Grace Policy
function* saveGracePolicySaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_GRACE_POLICY,
      action.payload
    );

    // 🔥 If API returns failure inside 200 response → treat as error
    if (response?.status === "failure") {
      yield put({
        type: types.SAVE_GRACE_POLICY_FAILURE,
        payload: response,
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.message || "Failed to save Grace Policy.",
      });

      return; // 🚫 stop further execution
    }

    // -----------------------------
    // ✅ SUCCESS - status = success
    // -----------------------------
    yield put({
      type: types.SAVE_GRACE_POLICY_SUCCESS,
      payload: response,
    });

    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });

  } catch (error) {
    // -----------------------------
    // ❌ NETWORK / SERVER ERROR
    // -----------------------------
    yield put({
      type: types.SAVE_GRACE_POLICY_FAILURE,
      payload: error,
    });

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to save Grace Policy.",
    });
  }
}


// Fetch Leave Policy
function* fetchLeavePolicySaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);

    const response = yield call(
      post,
      process.env.REACT_APP_GET_LEAVE_POLICY,
      formData
    );

    yield put({ type: types.FETCH_LEAVE_POLICY_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.FETCH_LEAVE_POLICY_FAILURE, payload: error });
  }
}

function* saveLeavePolicySaga(action) {
  if (action.payload instanceof FormData) {
    const obj = Object.fromEntries(action.payload.entries());
    console.log("FormData Object:", obj);
  }

  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_LEAVE_POLICY,
      action.payload
    );

    // Handle success response
    if (response?.status === 'success') {
      yield put({ type: types.SAVE_LEAVE_POLICY_SUCCESS, payload: response });

      Swal.fire({
        title: "Success",
        text: response?.message || "Leave Policy saved successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      return;
    }

    // Handle warning (failure but not system error)
    if (response?.status === 'failure') {
      yield put({ type: types.SAVE_LEAVE_POLICY_FAILURE, payload: response });

      Swal.fire({
        title: "Warning",
        text: response?.message || "Some details were not found.",
        icon: "warning",
        confirmButtonText: "OK",
      });

      return;
    }

    // Anything else is treated as a hard failure
    throw new Error(response?.message || "Failed to save leave policy Head!");
  } catch (error) {
    yield put({ type: types.SAVE_LEAVE_POLICY_FAILURE, payload: error });

    Swal.fire({
      icon: "error",
      title: "Error",
      text: error?.message || "Failed to save Leave Policy.",
    });
  }
}

// Root saga
function* gracePolicySaga() {
  yield takeLatest(types.FETCH_GRACE_POLICY_REQUEST, fetchGracePolicySaga);
  yield takeLatest(types.SAVE_GRACE_POLICY_REQUEST, saveGracePolicySaga);
  yield takeLatest(types.FETCH_LEAVE_POLICY_REQUEST, fetchLeavePolicySaga);
   yield takeLatest(types.SAVE_LEAVE_POLICY_REQUEST, saveLeavePolicySaga);
}

export default gracePolicySaga;
